import { FC } from "react";
import { IconPropsType } from ".";

export const Advertise: FC<IconPropsType> = (props) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22 5H3C1.89543 5 1 5.89543 1 7V17C1 18.1046 1.89543 19 3 19H22C23.1046 19 24 18.1046 24 17V7C24 5.89543 23.1046 5 22 5ZM3 4C1.34315 4 0 5.34315 0 7V17C0 18.6569 1.34315 20 3 20H22C23.6569 20 25 18.6569 25 17V7C25 5.34315 23.6569 4 22 4H3Z"
        fill={props.color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 4V3.5C5 3.22386 4.77614 3 4.5 3C4.22386 3 4 3.22386 4 3.5V4H5ZM4.5 2C3.67157 2 3 2.67157 3 3.5V5H6V3.5C6 2.67157 5.32843 2 4.5 2Z"
        fill={props.color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 4V3.5C12 3.22386 11.7761 3 11.5 3C11.2239 3 11 3.22386 11 3.5V4H12ZM11.5 2C10.6716 2 10 2.67157 10 3.5V5H13V3.5C13 2.67157 12.3284 2 11.5 2Z"
        fill={props.color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19 4V3.5C19 3.22386 18.7761 3 18.5 3C18.2239 3 18 3.22386 18 3.5V4H19ZM18.5 2C17.6716 2 17 2.67157 17 3.5V5H20V3.5C20 2.67157 19.3284 2 18.5 2Z"
        fill={props.color}
      />
      <path d="M5 5H6V7H5V5Z" fill={props.color} />
      <path d="M12 5H13V7H12V5Z" fill={props.color} />
      <path d="M19 5H20V7H19V5Z" fill={props.color} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.5 7H4.5C4.22386 7 4 7.22386 4 7.5V8H7V7.5C7 7.22386 6.77614 7 6.5 7ZM4.5 6C3.67157 6 3 6.67157 3 7.5V9H8V7.5C8 6.67157 7.32843 6 6.5 6H4.5Z"
        fill={props.color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.5 7H11.5C11.2239 7 11 7.22386 11 7.5V8H14V7.5C14 7.22386 13.7761 7 13.5 7ZM11.5 6C10.6716 6 10 6.67157 10 7.5V9H15V7.5C15 6.67157 14.3284 6 13.5 6H11.5Z"
        fill={props.color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.5 7H18.5C18.2239 7 18 7.22386 18 7.5V8H21V7.5C21 7.22386 20.7761 7 20.5 7ZM18.5 6C17.6716 6 17 6.67157 17 7.5V9H22V7.5C22 6.67157 21.3284 6 20.5 6H18.5Z"
        fill={props.color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13 20H12V23H13V20ZM11 19V24H14V19H11Z"
        fill={props.color}
      />
    </svg>
  );
};
